import { override } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';
import LogInModal from 'flarum/forum/components/LogInModal';

import { createAuth2, getUrlParams, isWeCom, onLoginSuccess, usePassword } from '../common/utils';
import WeComLogin from './components/WeComLogin';
import LoadingModal from './components/LoadingModal';

export default function setupLogin(corpId: string, agentId: string) {
  const { code } = getUrlParams();

  if (!app.data.session.userId) {
    if (code) {
      // 登录校验
      app.modal.show(LoadingModal);
      setTimeout(() => {
        WeComLogin.login(code)
          .then(onLoginSuccess)
          .catch(() => {
            app.modal.close();
            app.modal.show(LogInModal);
          });
      }, 0);
    } else if (isWeCom) {
      // 客户端授权登录
      app.modal.show(LoadingModal);
      location.replace(createAuth2(corpId, agentId, location.href, 'snsapi_privateinfo'));
    } else {
      // 浏览器扫码登录
      app.modal.show(LogInModal);
    }
  }

  Object.assign(LogInModal, {
    isDismissible: false,
  });

  override(LogInModal.prototype, 'fields', (fields: any) => {
    if (usePassword) {
      return fields();
    }
    return new ItemList().add('wecom-sdk-login', <WeComLogin corpId={corpId} agentId={agentId} />);
  });

  override(LogInModal.prototype, 'onsubmit', function (onsubmit: any, e: any) {
    e.preventDefault();
    this.loading = true;
    app.session
      .login(this.loginParams(), { errorHandler: this.onerror.bind(this) })
      .then(onLoginSuccess)
      .catch(this.loaded.bind(this));
  });

  override(LogInModal.prototype, 'footer', function () {
    return null;
  });
}
